import React from 'react';

const creditCashPoolFooter = () => (
    <p className={`u-fontSize13 u-textColorLight u-fontWeightRegular`}>By clicking on Pay Now, you are agreeing to Terms &amp; Conditions.</p>
);

export default creditCashPoolFooter;


// WEBPACK FOOTER //
// ./src/components/Payment/CreditCashPool/CreditCashPoolFooter/CreditCashPoolFooter.js